import { PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

interface Props {
  canWrite: boolean;
  onAdd: () => void;
}

const SavedResponsesEmptyState = ({ canWrite, onAdd }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="absolute bottom-full left-0 z-10 mb-2 flex w-full items-center justify-between gap-3 rounded-lg border border-border bg-background px-3 py-3 shadow-none">
      <p className="text-sm text-muted-foreground">{t('chatBox.panel.no_responses')}</p>
      {canWrite && (
        <Button type="button" size="sm" onClick={onAdd}>
          <PlusIcon size={14} />
          {t('chatBox.panel.add')}
        </Button>
      )}
    </div>
  );
};

export default SavedResponsesEmptyState;
